export default "__VITE_ASSET__46d8f69b__"